import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle, ChevronDown } from 'lucide-react';

/* Phone / tablet header for the course viewer (the desktop sidebar is hidden < lg):
   back link, progress and a tap-to-open list of every section. */
export function MobileSectionPicker({ course, sections, activeSection, onPick, completedCount, progressPct }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const current = sections[activeSection];
  return (
    <div className="lg:hidden" data-testid="course-mobile-nav">
      <div className="flex items-center justify-between gap-3 mb-2">
        <button type="button" onClick={() => navigate('/courses')} className="inline-flex items-center gap-1 text-sm text-neutral-500 hover:text-neutral-700 py-1" data-testid="course-mobile-back">
          <ArrowLeft size={14} />All Courses
        </button>
        <span className="text-xs text-neutral-500" data-testid="course-mobile-progress">{completedCount}/{sections.length} complete · {progressPct}%</span>
      </div>
      <div className="bg-white rounded-xl border border-neutral-200 overflow-hidden">
        <div className="h-1 bg-neutral-200"><div className="h-full bg-primary" style={{ width: `${progressPct}%` }} /></div>
        <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center gap-3 px-3.5 py-3 text-left" aria-expanded={open} data-testid="course-mobile-sections-toggle">
          <div className="flex-1 min-w-0">
            <div className="text-[11px] uppercase tracking-wide text-neutral-400 font-semibold">{course.title}</div>
            <div className="text-sm font-semibold text-neutral-900 truncate" data-testid="course-mobile-current">Section {activeSection + 1} of {sections.length} · {current?.title}</div>
          </div>
          <ChevronDown size={18} className={`text-neutral-400 shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
        {open && (
          <div className="border-t border-neutral-100 max-h-72 overflow-y-auto" data-testid="course-mobile-sections">
            {sections.map((s, i) => (
              <button key={s.id} type="button" onClick={() => { onPick(i); setOpen(false); }}
                className={`w-full text-left flex items-center gap-2.5 px-3.5 py-2.5 text-sm border-b border-neutral-50 last:border-0 ${i === activeSection ? 'bg-primary/10 text-primary font-medium' : 'text-neutral-700 active:bg-neutral-50'}`}
                data-testid={`course-mobile-section-${i}`}>
                {s.is_completed ? <CheckCircle size={16} className="text-green-500 shrink-0" /> : <span className="w-4 h-4 rounded-full border-2 border-neutral-300 shrink-0" />}
                <span className="truncate">{i + 1}. {s.title}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
